export const environment = {
  production: true,
  buildId: '3414034146422061',
  configFile: 'config.json',
};
